/* enrichment-carousel.js -- <enrichment-carousel>: prev/next arrows over a
   scroll-snap track (.enrichment-carousel__track > .enrichment-carousel__item).
   Arrows only show when the track overflows and only in the direction there
   is more to scroll. Optional data-arrow-target="<selector>" centres the
   arrows on that element inside the first item (e.g. a card image).
   Keyboard focus moving into an item scrolls it into view. */
if (!customElements.get('enrichment-carousel')) {
  customElements.define(
    'enrichment-carousel',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.enrichment-carousel__track');
        this.prev = this.querySelector('.enrichment-carousel__btn--prev');
        this.next = this.querySelector('.enrichment-carousel__btn--next');
        if (!this.track || !this.prev || !this.next) return;
        this.prev.addEventListener('click', () => this.step(-1));
        this.next.addEventListener('click', () => this.step(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        this.track.addEventListener('focusin', (e) => {
          const item = e.target.closest('.enrichment-carousel__item');
          if (item) this.reveal(item);
        });
        this.onResize = () => this.update();
        window.addEventListener('resize', this.onResize);
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.onResize);
          this.observer.observe(this.track);
        }
        this.update();
      }
      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
        if (this.observer) this.observer.disconnect();
      }
      step(dir) {
        const item = this.track.querySelector('.enrichment-carousel__item');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: dir * (item.offsetWidth + gap), behavior: 'smooth' });
      }
      reveal(item) {
        const t = this.track.getBoundingClientRect();
        const i = item.getBoundingClientRect();
        if (i.left < t.left) this.track.scrollBy({ left: i.left - t.left, behavior: 'smooth' });
        else if (i.right > t.right) this.track.scrollBy({ left: i.right - t.right, behavior: 'smooth' });
      }
      update() {
        const t = this.track;
        const overflow = t.scrollWidth - t.clientWidth > 2;
        const selector = this.dataset.arrowTarget;
        const target = selector && this.querySelector(selector);
        if (target && target.clientHeight) this.style.setProperty('--carousel-arrow-top', target.clientHeight / 2 + 'px');
        this.prev.hidden = !overflow || t.scrollLeft <= 2;
        this.next.hidden = !overflow || t.scrollLeft >= t.scrollWidth - t.clientWidth - 2;
      }
    }
  );
}
